import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import Layout from "@/components/layout";
import { useAuth } from "@/providers/auth.provider";
import Loading from "@/components/common/loading";

export const Route = createFileRoute("/(app)/_layout")({
  component: AppLayout,
});

function AppLayout() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const isNeedToLogin = !isAuthenticated && !isLoading;

  if (isLoading) {
    return <Loading />;
  }

  if (isNeedToLogin) {
    navigate({ to: "/login" });
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
